import { useState } from "react";
import "moment/locale/nl";

import moment from "moment";

import { DateSelector } from "./components/dateSelector";
import { Layout } from "./components/layout";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import { downloader } from "./utils/download";
import { DownloadButton } from "./components/downloadButton";

function App() {
  const [selectedDate, setDate] = useState<Date>(moment().toDate());
  const [busy, setBusy] = useState(false);
  const [msg, setMessage] = useState("");
  const { instance, accounts } = useMsal();

  moment().locale("nl");

  const _download = downloader(
    instance,
    accounts[0]
  )("api://9ecc6ebe-7faf-4496-b724-cc690d03b80c/sla-reports");

  const download = async (date: Date) => {
    setBusy(true);
    await _download(date, setMessage);
    setBusy(false);
  };

  console.log("selectedDate", selectedDate);

  return (
    <Layout>
      <Card style={{ margin: "auto", width: "300px", padding: "5px" }}>
        <Card.Title>Rapport periode:</Card.Title>
        <Card.Body>
          <DateSelector selectedDate={selectedDate} onChange={setDate} />
        </Card.Body>
        <Card.Footer>
          <Container>
            <Row>
              <Col>
                <DownloadButton
                  onClick={() => download(selectedDate)}
                  running={busy}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <p style={{ marginTop: "20px" }}>{msg}</p>
              </Col>
            </Row>
          </Container>
        </Card.Footer>
      </Card>
    </Layout>
  );
}

export default App;
